<template>
  <div>
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
  <g clip-path="url(#clip0_6182_7363)">
    <path d="M11.8616 8.51551L19.147 0.046875H17.4206L11.0947 7.40007L6.04225 0.046875H0.214844L7.85515 11.1662L0.214844 20.0469H1.94134L8.62162 12.2816L13.9574 20.0469H19.7848L11.8612 8.51551H11.8616ZM9.49695 11.2642L8.72283 10.1569L2.56342 1.34655H5.21521L10.1859 8.45682L10.9601 9.56405L17.4214 18.8063H14.7696L9.49695 11.2646V11.2642Z" fill="#2E5FE3"/>
  </g>
  <defs>
    <clipPath id="clip0_6182_7363">
      <rect width="20" height="20" fill="white" transform="translate(0 0.046875)"/>
    </clipPath>
  </defs>
</svg>
  </div>
</template>

<script>
export default {

}
</script>

<style>

</style>